import { BodyText, CaptionText } from '../Text/Heading';
import Text from '../Text/Text';

import Styled from '../../utils/Styled';

export const TitleText = Styled(BodyText, {
  numberOfLines: 2,
  fontSize: '16px',
  lineHeight: ['24px', '26px'],
});

export const SubtitleText = Styled(Text, {
  fontSize: ['12px', '14px'],
  lineHeight: ['16px', '18px'],
  fontWeight: 400,
  numberOfLines: 1,
});

export const HintText = Styled(CaptionText, {
  fontSize: ['10px', '12px'],
  lineHeight: ['13px', '16px'],
});

export const PriceOffText = Styled(Text, {
  fontSize: 14,
  color: '#036835',
});

export const PriceOffTextV2 = Styled(Text, {
  fontSize: 12,
  fontWeight: 500,
  color: '#036835',
  backgroundColor: '#E6F2EC',
  borderRadius: '4px',
  padding: '0px 3px',
  lineHeight: ['18px', '18px'],
});
